// extracted by mini-css-extract-plugin
export var downArrow = "_hl-0";
export var infoTooltipIcon = "_hl-3";
export var label = "_hl-1";
export var optionCard = "_hl-4";
export var upArrow = "_hl-2";